module.exports = __webpack_public_path__ + "img/utilityheavy_stopped.44eac67c.svg";